export default __webpack_public_path__ + "static/media/HoustonEsBack.c284b826.webp";